import navigation from "@/lang/af/navigation";
import generics from "@/lang/af/generics";
import questions from "@/lang/af/questions";
import a11y from "@/lang/af/a11y";
import velt from "@/lang/af/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
